export default Object.freeze({
  SUCCESS: {
    CODE: 200,
    MSG: 'success'
  },
  ERROR: {
    CODE: 400,
    MSG: 'error'
  },
  NO_ACTIVE_ERROR: {
    CODE: 4041000,
    MSG: 'device not active'
  },
  SERVER_ERROR: {
    CODE: 5001000,
    MSG: 'server error'
  },
  MAP_SUCCESS: {
    CODE: 0
  }
});



// WEBPACK FOOTER //
// ./src/constants/_return-code.js